import { render, staticRenderFns } from "./HeadlineComponent.vue?vue&type=template&id=776823e2&scoped=true"
import script from "./HeadlineComponent.vue?vue&type=script&lang=js"
export * from "./HeadlineComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "776823e2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/print-suite/source/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('776823e2')) {
      api.createRecord('776823e2', component.options)
    } else {
      api.reload('776823e2', component.options)
    }
    module.hot.accept("./HeadlineComponent.vue?vue&type=template&id=776823e2&scoped=true", function () {
      api.rerender('776823e2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/entries/formComponents/style-components/HeadlineComponent.vue"
export default component.exports